<template>
  <div class="site-connect-benefit-item-list">
    <BenefitItem
      v-for="item of items"
      :key="`stie-connect-benefit-item-${item.title}`"
      :icon="item.icon"
      :title="item.title"
      :text="item.text"
    />
  </div>
</template>
<script setup lang="ts">
import BenefitItem from '@/components/atom/benefit-item/BenefitItem.vue'
import type { BenefitItemListProps } from './benefit-item-list.types'

defineProps<BenefitItemListProps>()
</script>
<style lang="scss" scoped>
@import './benefit-item-list.scss';
</style>
